<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>

<div class="p-6 rounded-lg shadow-md bg-white">
  <div class="mb-8 text-center">
    <h1 class="flex items-center justify-center gap-3 text-4xl font-light text-gray-800 mb-2">
      <i class="pi pi-robot text-blue-600 text-3xl"></i>
      Redes Sociales
    </h1>
    <p class="text-lg text-gray-600 font-normal">Configuración y gestión de redes sociales</p>
  </div>

  <div class="mb-6 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
    <button pButton type="button" label="Crear Red Social" icon="pi pi-plus" class="p-button-success"
      (click)="openDialog()"></button>

    <div class="flex flex-col sm:flex-row sm:items-center gap-3">
      <div class="relative">
        <i class="pi pi-search absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 text-sm"></i>
        <input type="text" [(ngModel)]="searchTerm" (ngModelChange)="onSearchChange()"
          placeholder="Buscar por tienda, tipo o remitente..."
          class="pl-10 pr-10 py-2.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent w-full sm:w-80 transition-all">
        @if (searchTerm) {
        <button type="button" (click)="clearSearch()"
          class="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors">
          <i class="pi pi-times text-sm"></i>
        </button>
        }
      </div>
      <div class="flex items-center gap-2">
        <div class="text-sm text-gray-600 bg-green-300 px-3 py-1.5 rounded-full">
          <span class="font-medium">{{ getFilteredChannels().length }}</span> de {{ socialChannels.length }}
        </div>
      </div>
    </div>
  </div>

  <p-table [value]="getFilteredChannels()" [paginator]="true" [rows]="10" [tableStyle]="{ 'min-width': '50rem' }"
    responsiveLayout="scroll" *ngIf="socialChannels.length > 0" styleClass="p-datatable-striped">
    <ng-template pTemplate="header">
      <tr>
        <th class="bg-gray-100 text-gray-800 font-semibold border-b-2 border-gray-200 p-4">Tienda</th>
        <th class="bg-gray-100 text-gray-800 font-semibold border-b-2 border-gray-200 p-4">Sucursal</th>
        <th class="bg-gray-100 text-gray-800 font-semibold border-b-2 border-gray-200 p-4">Tipo de Canal</th>
        <th class="bg-gray-100 text-gray-800 font-semibold border-b-2 border-gray-200 p-4">ID del Canal</th>
        <th class="bg-gray-100 text-gray-800 font-semibold border-b-2 border-gray-200 p-4">Remitente</th>
        <th class="bg-gray-100 text-gray-800 font-semibold border-b-2 border-gray-200 p-4">Activo</th>
        <th class="bg-gray-100 text-gray-800 font-semibold border-b-2 border-gray-200 p-4">Acciones</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-channel>
      <tr class="border-b border-gray-200 hover:bg-gray-50">
        <td class="p-4 text-gray-700">
          {{ getShopName(channel.shopId) }}
        </td>
        <td class="p-4 text-gray-700">
          {{ getShopName(channel.shopPointId) }}
        </td>
        <td class="p-4">
          <span class="font-semibold text-gray-800">{{ getChannelTypeName(channel.channelType) }}</span>
        </td>
        <td class="p-4 text-gray-700">{{ channel.channelId }}</td>
        <td class="p-4 text-gray-700">{{ channel.sender }}</td>
        <td class="p-4">
          <p-tag [value]="channel.isActive ? 'Activo' : 'Inactivo'"
            [severity]="channel.isActive ? 'success' : 'danger'"></p-tag>
        </td>
        <td class="p-4 flex gap-2">
          <button pButton type="button" icon="pi pi-pencil" class="p-button-rounded p-button-warning p-button-sm"
            (click)="openDialog(channel)" pTooltip="Editar" tooltipPosition="top"></button>
          <button pButton type="button" icon="pi pi-trash" class="p-button-rounded p-button-danger p-button-sm"
            (click)="deleteChannel(channel)" pTooltip="Eliminar" tooltipPosition="top"></button>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="6" class="text-center p-4 text-gray-600">No hay redes sociales registradas</td>
      </tr>
    </ng-template>
  </p-table>

  <div class="text-center p-6 bg-gray-50 rounded-lg" *ngIf="socialChannels.length === 0">
    <p class="text-gray-600 mb-4">No hay redes sociales configuradas</p>
  </div>

  <p-dialog [(visible)]="showDialog" [header]="isEditMode ? 'Editar Red Social' : 'Crear Canal Social'" [modal]="true"
    [style]="{ width: '50vw' }" [breakpoints]="{ '960px': '75vw', '640px': '90vw' }" [blockScroll]="isSaving">

    <div *ngIf="isSaving" class="fixed inset-0 bg-black/10 backdrop-blur-sm flex items-center justify-center rounded-lg pointer-events-auto z-50" style="position: absolute; inset: 0; border-radius: inherit;">
      <div class="bg-white rounded-full p-8 shadow-xl">
        <svg class="animate-spin h-16 w-16 text-green-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
      </div>
    </div>

    <form [formGroup]="form" (ngSubmit)="saveChannel()" [ngClass]="{ 'opacity-50 pointer-events-none blur-sm': isSaving }">
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12 md:col-span-6">
          <label for="shopId" class="block mb-2 font-semibold text-gray-700">
            Tienda <span class="text-red-500">*</span>
          </label>
          <p-select id="shopId" formControlName="shopId" [options]="shops" optionLabel="name" optionValue="id"
            placeholder="Seleccione una tienda" (onChange)="onShopDropdownChange($event)" class="w-full"
            [disabled]="isEditMode"></p-select>
          <small class="text-red-500 text-sm" *ngIf="form.get('shopId')?.invalid && form.get('shopId')?.touched">
            Campo requerido
          </small>
        </div>

        <div class="col-span-12 md:col-span-6">
          <label for="shopPointId" class="block mb-2 font-semibold text-gray-700">
            Punto de Venta <span class="text-red-500">*</span>
          </label>
          <p-select id="shopPointId" formControlName="shopPointId" [options]="shopPoints" optionLabel="name"
            optionValue="id" placeholder="Seleccione un punto de venta" class="w-full"></p-select>
          <small class="text-red-500 text-sm"
            *ngIf="form.get('shopPointId')?.invalid && form.get('shopPointId')?.touched">
            Campo requerido
          </small>
        </div>

        <div class="col-span-12 md:col-span-6">
          <label for="channelType" class="block mb-2 font-semibold text-gray-700">
            Tipo de Canal <span class="text-red-500">*</span>
          </label>
          <p-select id="channelType" formControlName="channelType" [options]="channelTypes" optionLabel="label"
            optionValue="value" placeholder="Seleccione un tipo" class="w-full"></p-select>
          <small class="text-red-500 text-sm"
            *ngIf="form.get('channelType')?.invalid && form.get('channelType')?.touched">
            Campo requerido
          </small>
        </div>

        <div class="col-span-12 md:col-span-6">
          <label for="channelId" class="block mb-2 font-semibold text-gray-700">
            ID del Canal <span class="text-red-500">*</span>
          </label>
          <input id="channelId" pInputText formControlName="channelId" class="w-full" placeholder="Ej: +34600123456" />
          <small class="text-red-500 text-sm" *ngIf="form.get('channelId')?.invalid && form.get('channelId')?.touched">
            Campo requerido
          </small>
        </div>

        <div class="col-span-12 md:col-span-6">
          <label for="sender" class="block mb-2 font-semibold text-gray-700">
            Remitente <span class="text-red-500">*</span>
          </label>
          <input id="sender" pInputText formControlName="sender" class="w-full" placeholder="Nombre del remitente" />
          <small class="text-red-500 text-sm" *ngIf="form.get('sender')?.invalid && form.get('sender')?.touched">
            Campo requerido
          </small>
        </div>

        <div class="col-span-12 md:col-span-6">
          <label for="apiKey" class="block mb-2 font-semibold text-gray-700">
            API Key <span class="text-red-500">*</span>
          </label>
          <input id="apiKey" pInputText formControlName="apiKey" class="w-full" type="password"
            placeholder="Clave API" />
          <small class="text-red-500 text-sm" *ngIf="form.get('apiKey')?.invalid && form.get('apiKey')?.touched">
            Campo requerido
          </small>
        </div>

        <div class="col-span-12">
          <label for="apiHostUri" class="block mb-2 font-semibold text-gray-700">
            API Host URI <span class="text-red-500">*</span>
          </label>
          <input id="apiHostUri" pInputText formControlName="apiHostUri" class="w-full"
            placeholder="https://api.ejemplo.com" />
          <small class="text-red-500 text-sm"
            *ngIf="form.get('apiHostUri')?.invalid && form.get('apiHostUri')?.touched">
            Campo requerido
          </small>
        </div>

        <div class="col-span-12 md:col-span-6">
          <div class="flex items-center gap-2 pt-6">
            <p-checkbox formControlName="isActive" [binary]="true" inputId="isActive"></p-checkbox>
            <label for="isActive" class="font-semibold text-gray-700">Activo</label>
          </div>
        </div>
      </div>

      <div class="flex justify-end gap-2 pt-4 border-t border-gray-200">
        <button pButton type="button" label="Cancelar" icon="pi pi-times" class="p-button-text"
          (click)="closeDialog()" [disabled]="isSaving"></button>
        <button pButton type="submit" [label]="isEditMode ? 'Actualizar' : 'Crear'" icon="pi pi-check"
          class="p-button-success" [disabled]="form.invalid || isSaving" [loading]="isSaving"></button>
      </div>
    </form>
  </p-dialog>
</div>
